<!--
    Name:公告管理
    Date:2021-09-03
    Author:cuiyunxiao
-->

<template>
    <div class="st-main-content">
        <common-search-form
            ref="commonSearch"
            :formOptions="formOptions"
            @onSearch="onSearch"
        ></common-search-form>

        <div class="data-table-box">
            <common-table
                ref="CommonTableRef"
                :tableColumns="tableColumns"
                :data="dataList"
                :loading="loading"
                :showPage="togglePage"
                :pageConfig="pageConfig"
                :bottomHandleArr="bottomHandleArr"
                @selectionChange="selectionChange"
                @currentChange="currentChange"
                @sizeChange="sizeChange"
            >
           
            </common-table>
        </div>
        <div class="previewImg" v-if="toggleImg">
            <img
                @click="toggleImg = false"
                class="closeImg"
                src="../../assets/images/close.png"
                alt=""
            />
            <div class="previewImgWarp">
                <div class="mypreviewImg">
                    <img :src="previewPath" />
                </div>
            </div>
        </div>

        <!-- 查看上传的商品图 
            <el-dialog>
                <el-carousel :interval="4000" type="card" height="200px">
                    <el-carousel-item v-for="item in previewList" :key="item">
                        <img :src="item"></img>
                    </el-carousel-item>
                </el-carousel>
            </el-dialog>
        -->
        

        <!--商品的维护的处理-->
        <el-dialog
            id="productDialog"
            title="新增/编辑公告"
            :visible.sync="showProductDialog"
            width="800px"
            center
            @close="toCloseProductDialog"
            :close-on-click-modal="false"
        >
            <el-form
                :model="productForm"
                ref="productForm"
                :rules="productFormRule"
                label-width="120px"
            >
			
			<el-form-item label="选择公告类型">
			   <el-select v-model="productForm.type" placeholder="请选择" size="small">
			   	<el-option v-for="item in options" :key="item.value" :label="item.label"
			   		:value="item.value">
			   	</el-option>
			   </el-select>
			</el-form-item>
                <!--放置一个富文本-->
                <el-form-item label="图文详情">
                    <div id="graphicDetails"></div>
                </el-form-item>
                <el-form-item style="text-align:right">
                    <el-button @click="toCloseProductDialog">取消</el-button>
                    <el-button type="primary" @click="submitAddEditProduct"
                        >确认</el-button
                    >
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
let editor = null;
import E from "wangeditor";

export default {
    name: "Recommend",
    props: [],
    data() {
        return {
			options: [{
				value: 'OWNER_MINI_INSTRUCTIONS',
				label: '货主公告'
			}, {
				value: 'DRIVER_MINI_INSTRUCTIONS',
				label: '司机公告'
			}],
			editor:null,
            dialogVisible: false, // 查看大图的展示
            dialogImageUrl: null, // 查看大图的链接
            // 商品的表单信息
            productForm: {
               type: "",
                 content: "string",
				 createTime: new  Date().getTime(),
				 id: '',
				 updateTime:new  Date().getTime(),
                 type: "string",
             
            },
            productFormRule: {
           //      goodsName: [
           //          {
           //              required: true,
           //              message: "商品名称 不能为空",
           //              trigger: "change"
           //          }
           //      ],
           
          
             
            },
            isAdd: true, // 是否是新增
            showProductDialog: false, // 展示商品新增/编辑的弹窗
            userTypes: [],
            searchParams: {},
            formOptions: [
                
                {
                    label: "公告类型",
                    prop: "type",
                    element: "el-select",
                    keyName: "value",
                    labelName: "label",
                    options: [{
				value: 'OWNER_MINI_INSTRUCTIONS',
				label: '货主公告'
			}, {
				value: 'DRIVER_MINI_INSTRUCTIONS',
				label: '司机公告'
			}]
                },
                
            ],
            tableColumns: [
                {
                    title: "序号",
                    index: true,
                    fixed: "left"
                },
                {
                    key: "",
                    title: "操作",
                    align: "center",
                    operate: true,
                    width:145,
                    fixed: "left",
                    setBtns: (row, index) => {
                        let btns = [];
                        btns.push({
                            label: "编辑",
                            type: "primary",
                            handler: (row, index) =>
                                this.editProduct(row, index, "edit")
                        });
                    
                        btns.push({
                            label: "删除",
                            type: "primary",
                            handler: (row, index) =>
                                this.deleteProduct(row,index)
                        });
                                            
                        return btns;
                    }
                },
               
			   {
			       key: "type",
			       title: "公告类型",
			       render: (h, { row }) => {
			           return h(
			               "span",
			               row.type == 'OWNER_MINI_INSTRUCTIONS' ? "货主端公告" : "司机端公告"
			           );
			       }
			   },
               
                // { key: "salesVolume", title: "销量" ,width:80},
                // { key: "imgUrls", slot: true, slotName: "imgUrls", title: "商品图" ,width:90},
                // { key: "needScore", title: "所需积分" ,width:80},
                // { key: "scoreDeduction", title: "积分抵扣",width:80 },
                // { key: "marketPrice", title: "市场价",width:80 },
                // { key: "discountPrice", title: "销售价",width:80 },
                // { key: "shopName", title: "所属店铺",width:80 },
                // { key: "className", title: "店铺分类",width:80 },
                // { key: "typeName", title: "商品类型",width:80 },
                // {
                //     key: "freeShipping",
                //     title: "是否包邮",
                //     render: (h, { row }) => {
                //         return h(
                //             "span",
                //             row.freeShipping == 1 ? "包邮" : "不包邮"
                //         );
                //     }
                // },
                
                {
                    key: "createTime",
                    width: 130,
                    title: "创建时间",
                    render: (h, { row }) => {
                        return h(
                            "span",
                            this.$util.dateUtil.formatTime(
                                row.createTime,
                                "Y-M-D h:m"
                            )
                        );
                    }
                },
                {
                    key: "updateTime",
                    width: 130,
                    title: "更新时间",
                    render: (h, { row }) => {
                        return h(
                            "span",
                            this.$util.dateUtil.formatTime(
                                row.updateTime,
                                "Y-M-D h:m"
                            )
                        );
                    }
                },
               
            ],

            pageConfig: {
                total: 0,
                pageSize: 100,
                currentPage: 1
            },
            bottomHandleArr: [
                {
                    label: "新增",
                    handler: () => this.addProduct()
                }
                // {
                //     label: "导出",
                //     handler: () => this.exportTable()
                // }
            ],
            loading: false,
            showPage: false,
            toggleImg: false,
            previewPath: '',
            dataList: [], //订单列表
            searchParams: {},
            togglePage: false, //是否显示分页
            fileList: [
                // {url:"http://www.zglljc.com/uploads/image/20210329/3e5c2375bda5d8b8478e10420a1ebd33.jpg",name:"测试商品"},
            ], // 已经上传的图片列表
            shopList:[], // 店铺的列表
            classList:[],// 店铺对应分类的列表 
            currentRow:{},// 当前操作的数据
            showProductAuditDialog:false,// 显示商品的审核
        };
    },
    computed:{
        userInfo(){
            let val = sessionStorage.getItem("userInfo");
            return val ? JSON.parse(val) : {};
        },
    },
    created() {},
    methods: {
        // 关闭产品审核的弹窗
        closeProductAudit(){

        },
   
   
        showAllImg(imgIn){
            let img = this.getFirstImg(imgIn)
            this.previewPath = img;
            this.toggleImg = true;
        },
        // 获取首图
        getFirstImg(imgStrs){
            let arr = imgStrs.split(",");
            return arr[0] || '';
        },
      
        // 编辑商品
        editProduct(row, index, type, setVal = 0) {

  this.productForm.id = this.dataList[index].id
			this.showProductDialog = true;
			this.$nextTick(() => {
			    // 重置表单的校验规则
			    // this.$refs.productForm.resetFields();
			    // this.initEditor(row)
				console.log(this.editor)
				 if (this.editor==null){
				          this.initEditor(row);
				          editor.txt.html(row.content);
				        }else {
				          this.editor.destroy();//这里做了一次判断，判断编辑器是否被创建，如果创建了就先销毁。
				          this.initEditor(row);
				          this.editor.txt.html(row.content);
				        }
	
			});
                this.productForm.type = row.type;
				this.productForm.content = row.content;
				// this.productForm.id = index + 1;
			
		
        },
        // 新增
        addProduct(row) {
			   this.showProductDialog = true;
          this.productForm.type = '';
          this.productForm.content = '';
          this.productForm.id = '';
            // 新增的时候清空上传组件
            this.fileList = [];  // 测试的时候暂时不清除
            
            this.productForm = {
				type: "",
                content: "string",
                createTime: new  Date().getTime(),
                id: '',
                updateTime:new  Date().getTime(),
            };
            this.isAdd = true;
            if (row) {
                this.isAdd = false;
                // 给 productForm 赋值
            }
         
            this.$nextTick(() => {
                // 重置表单的校验规则
                // this.$refs.productForm.resetFields();
                // this.initEditor()
				console.log(this.editor)
				if (this.editor==null){
				          this.initEditor();
				        }else {
				          this.editor.destroy();//这里做了一次判断，判断编辑器是否被创建，如果创建了就先销毁。
				          this.initEditor();
				        }
		
            });
        },

        initEditor(row){
		
            editor = new E("#graphicDetails");
			this.editor = editor
			
            // 或者 const editor = new E( document.getElementById('div1') )
            editor.config.uploadImgHeaders = {
                token:localStorage.getItem('token')
            }
            editor.config.uploadFileName = 'file'
            editor.config.uploadImgAccept = ['jpg', 'jpeg', 'png', 'gif']
            if(process.env.NODE_ENV == 'development'){
                editor.config.uploadImgServer = '/api/file/upload'
            }else{
                editor.config.uploadImgServer = '/admin/file/upload'
            }
        editor.config.uploadImgHooks = {
        	// 图片上传并返回了结果，想要自己把图片插入到编辑器中
        	// 例如服务器端返回的不是 { errno: 0, data: [...] } 这种格式，可使用 customInsert
        	customInsert: function(insertImgFn, result) {
        		// result 即服务端返回的接口
        		console.log('customInsert', result)
        
        		// insertImgFn 可把图片插入到编辑器，传入图片 src ，执行函数即可
        		insertImgFn(result.data.url)
        	}
        }
            editor.create();
      
       
        },
		//删除
		deleteProduct(row){
			console.log(row)
			this.$server.system.deleteNotice(row.id, res => {
			    if (res.code == 0) {
			        this.$message.success("删除成功");
			        this.$refs.commonSearch.onSearch();
			    } else {
			        this.$message(res.message);
			    }
			});
		},
        upDateProduct(row) {
		
			row.id = this.productForm.id
			
			console.log(this.productForm)
            this.$server.system.AddEdit(row, res => {
                if (res.code == 0) {
                    this.showProductDialog = false;
                    this.$message.success(row.id ? "编辑成功" : "新增成功");
                    this.$refs.commonSearch.onSearch();
                } else {
                    this.$message(res.message);
                }
            });
        },

        // 设置整型的数据
        setInt(val, word) {
            if (String(Number(val)) == "NaN") {
                val = 1;
            } else {
                val = parseInt(val);
            }
            this.$set(this.productForm, word, val);
        },
       
        // 查看大图
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        // 移除图片
        handleRemove(file, fileList) {
            // console.log(fileList, "fileList");
            // console.log(this.fileList, "this.fileList");
            console.log(file, fileList);
            let index = this.fileList.findIndex((item)=>{
                return item.name == file.name
            });
            this.fileList.splice(index,1)
        },

        // 确认编辑商品
        submitAddEditProduct() {
            this.$refs.productForm.validate(valid => {
                let row = { ...this.productForm };
                let str = '',arr = [];
                row.content = editor.txt.html();
                this.upDateProduct(row);
            });
        },

        // 关闭商品编辑的弹窗
        toCloseProductDialog() {
            this.showProductDialog = false;
           
            editor = null;
        },
        sizeChange(size) {
            this.pageConfig.currentPage = 1;
            this.pageConfig.pageSize = size;
            this.searchList();
        },
        currentChange(currentPage) {
            this.pageConfig.currentPage = currentPage;
            this.searchList();
        },
  
        argImg(src) {
            this.previewPath = src;
            this.toggleImg = true;
        },
		//查询 
        onSearch(val) {
            console.log(val, "val");
            val = Object.assign({}, val);
            val.beginDate = val.createTimeArr
                ? new Date(val.createTimeArr[0])
                : null;
            val.endDate = val.createTimeArr
                ? new Date(val.createTimeArr[1])
                : null;
            this.searchParams = Object.assign({}, this.searchParams, val);
            this.searchList(true);
        },
        searchList(flag) {
            let pages = {};
            pages.size = this.pageConfig.pageSize;
            pages.current = this.pageConfig.currentPage;
            if (flag) pages.current = 1;
            let searchParams = this.searchParams;
            this.loading = true;
            Object.assign(searchParams, pages);
            this.getData(searchParams);
        },

        getData(data) {
            this.$server.system.getNotice(data, res => {
                this.loading = false;
                if (res.code == 0) {
                    this.dataList = res.data.records;
				
                    this.pageConfig.total = res.data.total;
                    this.pageConfig.currentPage = res.data.current;
                    if (res.data.total > 0) {
                        this.togglePage = true;
                    }
                }
            });
        },
      
        selectionChange(row) {
            this.selectedList = row;
        },
        cellClass(row) {
            if (row.columnIndex === 0) {
                return "disabledCheck";
            }
        }
    },
    mounted() {
        // this.getShopList();// 要作为查询条件
        // this.$server.codeMall.productType({}, res => {
        //     console.log(res, "商品类别");
        //     if (res.code == 0) {
        //         this.catogoryList = res.data;
        //         this.formOptions[2].options = res.data;
        //     }
        // });

        this.$refs.commonSearch.onSearch();
    }
};
</script>
<style scoped lang="scss">
.st-main-content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.activity-content{
    border:1px solid red;
    legend{
        font-size:12px;
        margin-left:12px;
        color:red;
    }
}
.data-table-box {
    height: auto;
    background: #fff;
    padding: 8px;
    box-sizing: border-box;
}

.data-table {
    margin-bottom: 8px;
}

.query-setting-box-left {
    flex-grow: 0;
}

.previewImg {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 99;
}

.previewImgWarp {
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -300px;
    margin-top: -300px;
    width: 600px;
    height: 600px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.mypreviewImg {
    display: inline-block;
    border: 5px solid #fff;
    border-radius: 3px;
    overflow: hidden;
}

.mypreviewImg img {
    max-width: 600px;
}

.closeImg {
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
}
#productDialog /deep/ .el-dialog {
    margin-top: 15px !important;
}
.smallImg{
    height:30px;
}
</style>
